<template>
  <div class="projects">
    <div class="pageContent">
      <heading type="h1">Projects</heading>
    </div>
  </div>
</template>

<script>
import Heading from '@/components/Heading/heading'

export default {
  name: 'projects',
  components: {
    Heading
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/projects.vue